module.exports = __webpack_public_path__ + "static/media/20170806_23day_1230AT.5639be8f.jpg";